import { ClientDashboard, PageStyle, InputError, InputText, Form, useRef, FormikControl, Formik, FormStyle, Button, useRouter, useState, Plus,
         SkipModal, useSWR, clearSWRCache, useEffect, MY_ACCOUNT, ErrorPages, Error, MyAccountAction, CustomCropper, useTranslation,
         QuickAdd, useUser, Loading, COMMON, getSession, PAGE_ANIMATION_OPTIONS, motion,Checkbox, QUESTIONS, MY_INTERVIEW_JOBS, axios, API, Link, REDIRECT, DefaultCheckbox, CheckedCheckbox} from "@/imports-files/pages/clients/my-account";
import { UserSwitch } from '@/components/user-switch';
import MyInterviewWidget from '@/pages/clients/dashboard/recruitments/my-interview-widget';
import { PlayVideoModal } from "@/components/modals/play_video_modal";
import { CommonAction } from "@/actions/common/common";
import { SidebarAction } from '@/imports-files/components/sidebar';

function MyAccount(props) {
  clearSWRCache('my-account-data');
  const {t}= useTranslation()
  const [showLoader, setShowLoader] = useState(false);
  const [apiError, setApiError] = useState(null);
  const myAccountAction = new MyAccountAction(setApiError, setShowLoader,t);
  const errorPages = new ErrorPages()
  const editorRef = useRef(null);
  const router = useRouter();
  const sidebarAction                               =   new SidebarAction(router, t);
  const commonAction                                =   new CommonAction();
  const step = router.query.step
  const isQuickSetup = router.query.step && router.query.step == 'my_account' ? true : false
  const [skipModal, setSkipModal] = useState(false);
  const { data, error } = useSWR('my-account-data', () => { return myAccountAction.getUserDetails(router) }, {revalidateOnFocus: false});
  const [initialValues, setInitialValues] = useState({})
  const [userRoles, setUserRoles] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [imageError, setImageError] = useState('');
  const { user, clearUser, updateUser } = useUser();
  const [session, setSession] = useState(props.session);
  const [showVideo, setShowVideo] = useState(false);
  const [imageUploadedData, setImageUploadedData] = useState([]);
  const [isActive, setIsActive]     =    useState(false);
   function closeDropDown(setIsActive)
  {
    setTimeout(()=> setIsActive(false), 50)
  }
  useEffect(() => {
    (async () => {
      if (data) {
        var profileData = data?.user  // await sidebarAction.getProfilePhotoUrl(session)
        var base64Data = await commonAction.convertUrlToBase64(profileData.photo_url);
        await updateUser({user_image: base64Data, user_name: profileData?.name, user_id: session?.slug, name_initials: profileData?.name_initials});
        if(profileData.photo_url){
          document.querySelector('.AvatarImage').src = profileData?.photo_url || COMMON.DUMMY_IMAGE;
          sidebarAction.showImageOrInitials(true)
        }
        else{
          document.querySelector('.AvatarInitials').innerText = profileData?.name_initials
          sidebarAction.showImageOrInitials(false);
        }
        document.querySelector('.AvatarName').textContent = profileData?.name;
        setInitialValues(data?.user)
        setUserRoles(data.user_roles)
        setLoading(false)

        if (isQuickSetup)
          setTimeout(() => {
            new SidebarAction().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, 'my_account');
          }, 750);

      }
    })();
  }, [data])



  function handleIsChecked(event, formik, name)
    {
      let isChecked = event.target.checked
      formik.setFieldValue(name, isChecked);
    }

  if (isLoading || error || errorPages.handleErrorCodes(apiError?.status)) {
    var renderPage = (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage;
  }

  return (
    <motion.div key={router.route} initial="pageInitial" animate="pageAnimate" variants={PAGE_ANIMATION_OPTIONS}>
      <div className={`acprofile DashboardPageContent ${PageStyle.accountprofile} ${PageStyle.JobList} ${PageStyle.NewJob}`}>
        <div className={PageStyle.NewJob__Container}>
              {session?.role != 'reviewer' &&
                  <QuickAdd session={session} />}

          <div className={PageStyle.ClientCompany__FormSection}>
            <h1 className={`mt0 ${PageStyle.ClientCompany__Heading}`}>
              {t("my_account:heading")}
            </h1>
          </div>

          <div className={`CandidateListForm`}>

            <Formik
              initialValues={initialValues}
              validationSchema={MY_ACCOUNT.VALIDATION_SCHEMA}
              onSubmit={async (values, actions) => {
                let parser = new DOMParser();
                var doc = parser.parseFromString(values.email_signature, "text/html");
                var img_array = []
                for(let element of doc.getElementsByTagName('img'))
                {
                  img_array.push(element.src)
                  if ((element.src.includes('https://') || element.src.includes('http://')) && !element.src.includes(`email-signature/users/${session.id}`))
                  {
                   let encode_image = await myAccountAction.imageToBase64(element);
                    element.src = encode_image;
                  }
                };
                let filter_deleted_image_urls = imageUploadedData.filter((a) => !img_array.includes(a));
                const xmlSerializer = new XMLSerializer();
                const stringifiedContent = xmlSerializer.serializeToString(doc);
                values.email_signature = stringifiedContent
                const errors = await myAccountAction.updateUserDetails(values, router, isQuickSetup, updateUser, initialValues.slug, setInitialValues, filter_deleted_image_urls);
                actions.setErrors(errors)
              }}
            >

              {(formik) => (
                <Form className={`${PageStyle.Form} width100 AddCandidateForm`}>
                  <div className={PageStyle.Form__Table}>
                    <div className={PageStyle.Form__TableRow}>
                      <div className={PageStyle.Form__TableCol}>
                        <div className={PageStyle.accountprofile__ProfilePicture}>
                          {/* <Image src={selectedFile} alt='' width={200} height={200} />  */}
                          <img id="User_Profile" src={formik.values.photo_url ? formik.values.photo_url : COMMON.DUMMY_IMAGE} />
                          {!process.env.NEXT_PUBLIC_HEARTPACE && <div style={{ display: "grid" }}>
                            <label className={PageStyle.primarybtn}>

                              <input id='from_device' className='inputvisibleidden' type="file" accept=".png, .jpg, .jpeg" onChange={(event) => { myAccountAction.onFileChange(event, formik, setImageError) }} name="user_photo" />
                              {t("button:upload_new_picture")}</label>
                            {imageError && <p className={` p0 ${PageStyle.Form__DropBoxError}`}><Error /> {imageError}</p>}</div>}
                        </div>
                      </div>
                    </div>

                    <div className={PageStyle.Form__TableRow}>
                      <div className={PageStyle.Form__TableCol}>
                        <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, "role_id")}>
                          <span className={`red-color`}>*</span>&nbsp;{t("my_account:role")}
                        </label>

                        <FormikControl
                          control="select"
                          type="text"
                          /*  placeholder    =   {MY_ACCOUNT.texts.placeholder_1} */
                          name="role_id"
                          className={`${PageStyle.Form__CustomSelect} width398`}
                          formik={formik}
                          default={formik.values.role_id || ''}
                          errorClass={PageStyle.Form__Error}
                          style={InputError(formik, "role_id")}
                          options={userRoles}
                          disabled={true}
                        />
                      </div>

                      <div className={PageStyle.Form__TableCol}>
                        <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, "name")}>
                          <span className={`red-color`}>*</span>&nbsp;{t("my_account:name")}
                        </label>

                        <FormikControl
                          control="input"
                          type="text"
                          /*  placeholder      =     {MY_ACCOUNT.texts.placeholder_2} */
                          name="name"
                          className={PageStyle.Form__Input}
                          formik={formik}
                          errorClass={PageStyle.Form__Error}
                          style={InputError(formik, "name")}
                          disabled={true}
                        />
                      </div>
                    </div>

                    <div className={PageStyle.Form__TableRow}>
                      <div className={PageStyle.Form__TableCol}>
                        <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, "email")}>
                          <span className={`red-color`}>*</span>&nbsp;{t("my_account:email")}
                        </label>

                        <FormikControl
                          control="input"
                          type="text"
                          /* placeholder    =   {MY_ACCOUNT.texts.placeholder_4} */
                          name="email"
                          className={PageStyle.Form__Input}
                          formik={formik}
                          disabled={true}
                          errorClass={PageStyle.Form__Error}
                          style={InputError(formik, "email")}
                        />
                      </div>
                      <div className={PageStyle.Form__TableCol}></div>
                    </div>

                    <div className={PageStyle.Form__TableRow}>
                      <div className={PageStyle.Form__TableCol}>
                        <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'email_signature')}>
                          {" "}
                          {t("my_account:email_sign")} {/* <span className={PageStyle.Form__Cont}>(Optional)</span> */}
                        </label>

                        <FormikControl
                          selector={"#email-signature"}
                          apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                          control="customEditor"
                          formik={formik}
                          onInit={(evt, editor) => editorRef.current = editor}
                          textareaName="email_signature"
                          style={InputError(formik, 'email_signature')}
                          value={formik.values.email_signature}
                          onEditorChange={ (value) => {
                             formik.setFieldValue("email_signature", value)
                          }
                          }
                          init={{
                            height: 250,
                            menubar: false,
                            readOnly: false,
                            resize: false,
                            plugins: [
                              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                              'insertdatetime', 'media', 'table', 'help', 'wordcount'
                            ],
                            toolbar: 'undo redo | blocks | ' +
                              'bold italic backcolor | image | link | alignleft aligncenter ' +
                              'alignright alignjustify | bullist numlist outdent indent | ' +
                              'removeformat | help',
                              images_upload_handler: function (blobInfo, success, failure) {
                                return new Promise((resolve, reject) => {
                                  let user_id = session.id
                                  const xmlRequest = new XMLHttpRequest();
                                  const formData = new FormData();

                                  xmlRequest.withCredentials = false;
                                  xmlRequest.open('POST', API.open.UPLOAD_SIGNATURE_IMAGE);

                                  xmlRequest.onload = () => {
                                    if (xmlRequest.status == 200) {
                                      const response = JSON.parse(xmlRequest.response);
                                      imageUploadedData.push(response.location)
                                      setImageUploadedData([...imageUploadedData])
                                      resolve(response.location);
                                    } else {
                                      reject('HTTP Error: ' + xmlRequest.status);
                                    }
                                  };
                                  xmlRequest.onerror = () => {
                                    reject('Image upload failed due to a XHR Transport error. Code: ' + xmlRequest.status);
                                  };
                                  let image_base_64 = blobInfo.base64();
                                  let file_format = blobInfo.blob().type;
                                  formData.append("user_id", user_id)
                                  formData.append("encoded_image", image_base_64)
                                  formData.append("file_format", file_format)
                                  xmlRequest.send(formData);
                                });
                              },
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                          }}
                        />
                      </div>
                    </div>

                    {!process.env.NEXT_PUBLIC_HEARTPACE && <div className={`${PageStyle.Form__Container} ${PageStyle.Form__TextLeft}`}>
                      <span className={PageStyle.Form__CheckLabel}>{t("my_account:bottom_description")} </span>
                        <div className={`${PageStyle.Form__LabelCheck} Mui__CustomCheckbox`}>

                          <Checkbox     
                                        name = "newsletter"
                                        onChange={(event) => handleIsChecked(event, formik, "newsletter")}
                                        checked        =   {formik.values?.newsletter || false}
                                        icon = {<DefaultCheckbox/>}
                                        checkedIcon = {<CheckedCheckbox/>}
                          />{" "}
                          {t("checkbox:sign_me_up")} </div>
                    </div>}

                    {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
                    <div className="space"></div>
                    {!isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>
                      {!process.env.NEXT_PUBLIC_HEARTPACE ? <Button buttonstyle={PageStyle.secondarybtnborder}
                        type="button"
                        onClick={() => myAccountAction.handleLogout(router)}
                      >
                       {t("button:sign_out")}
                      </Button> : <p></p>}

                      <Button buttonstyle={PageStyle.primarybtn}
                        type="submit"
                      >
                        {t("button:save_changes")}
                      </Button>
                    </div>}

                    {isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>

                      <Button buttonstyle={PageStyle.secondarybtnborder}
                        type="button"
                        onClick={() => { setSkipModal(true) }}
                      >
                        {t("button:skip")}
                      </Button>

                      <Button buttonstyle={PageStyle.primarybtn}
                        type="submit"
                      >
                        {t("button:next")}
                      </Button>
                    </div>}
                  </div>

                </Form>
              )}
            </Formik>
          </div>

        </div>
        {showLoader && <Loading />}
        {<CustomCropper viewProfileAction={myAccountAction} />}
        {showVideo && <PlayVideoModal hashKey={data.user.introduction_video_key} setIntroModal={setShowVideo}></PlayVideoModal>}
      </div>
    </motion.div>
  );
}

MyAccount.layout = ClientDashboard;
export default MyAccount;